import { render, staticRenderFns } from "./AssetClassArea.vue?vue&type=template&id=00d8064e&scoped=true&"
import script from "./AssetClassArea.vue?vue&type=script&lang=js&"
export * from "./AssetClassArea.vue?vue&type=script&lang=js&"
import style0 from "./AssetClassArea.vue?vue&type=style&index=0&id=00d8064e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8064e",
  null
  
)

export default component.exports